var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottom = function SvgBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7685 18C18.9888 18 18.3162 18.5476 18.1582 19.3112L14.0346 39.2422C13.8383 40.1909 14.5005 41.1027 15.4632 41.2097L26.5227 42.4385C27.3407 42.5294 28.1 42.0015 28.2996 41.203L28.3394 41.0437C28.7546 39.383 31.1148 39.383 31.53 41.0437L31.5698 41.203C31.7694 42.0015 32.5286 42.5294 33.3467 42.4385L44.4061 41.2097C45.3689 41.1027 46.0311 40.1909 45.8348 39.2422L41.7111 19.3112C41.5532 18.5476 40.8806 18 40.1009 18H30.3314H29.538H19.7685Z",
    fill: "#2D3336"
  })));
};
export default SvgBottom;